// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../.yarn/__virtual__/css-loader-virtual-2ae40ad6f9/0/cache/css-loader-npm-3.5.3-0f886851e6-e5fa1707d7.zip/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pricing-cell-wrapper .actions-wrapper{flex:0.1;display:flex;flex-direction:row;padding:0 10px}.pricing-cell-wrapper .flex-wrapper{flex:1;display:flex;justify-content:flex-end}.pricing-cell-wrapper .cancel-button{padding:10px}\n", ""]);
// Exports
module.exports = exports;
